// Format the formatted JSON XML to a more suitable format
const formatData = (jsonData) => {
	const output = [];

	jsonData.Courses.forEach((item) => {
		const newEntry = {};

		// Make sure keys are lowercase
		Object.entries(item.Attributes).forEach((attribute) => {
			const key = attribute[0].toLowerCase();
			const value = attribute[1];
			newEntry[key] = value;
		});

		// Add to the output
		output.push(newEntry);
	});

	// Sort
	output.sort((a, b) => (b.classtitle < a.classtitle ? 1 : -1));

	return output;
};

export default formatData;
